module.exports = __webpack_public_path__ + "FixelDisplay-SemiBold-0c998ae40d18a7d96809ced49502b7ce.woff2";